import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { ReactNode } from "react";
import { Typography } from "@platform/design-system";

function InfoMessage({
  children,
  tooltipMsg,
}: {
  children?: ReactNode;
  tooltipMsg?: string;
}): React.JSX.Element {
  return (
    <>
      <Typography variant="body-medium">
        <em>{children}</em>
      </Typography>
      {tooltipMsg ? (
        <Tooltip
          arrow
          placement="top"
          sx={{ fontSize: 19, marginLeft: 1 }}
          title={tooltipMsg}
        >
          <InfoIcon />
        </Tooltip>
      ) : null}
    </>
  );
}

export default InfoMessage;
